module.exports = __webpack_public_path__ + "img/sign_in_bg1.27e042c2.jpg";